import React from 'react';
import { Flex } from '@withjoy/joykit';
import type { PriceValuePropAsset } from '../../../propValues.types';
import { useIsMobileScreen } from '@shared/utils/media/useMediaScreens';
import { treatmentDesktopAspect, treatmentMobileAspect } from '../../CardsConfig';
import { ProductPrices } from './ProductPrices/ProductPrices';

type PriceValuePropCardProps = {
  data: PriceValuePropAsset & { type: 'priceValueProp' };
};

export const PriceValuePropCard = ({ data }: PriceValuePropCardProps) => {
  const isMobile = useIsMobileScreen();

  return (
    <Flex
      gridArea="auto"
      // This card is only injected in the hide-price treatment, so it always uses the treatment aspect ratio.
      aspectRatio={isMobile ? treatmentMobileAspect : treatmentDesktopAspect}
      alignItems="center"
      justifyContent="center"
      background="hsla(45, 12%, 93%, 1)"
      border="1px solid hsl(0, 0%, 90%)"
      width="100%"
      height="100%"
    >
      <ProductPrices template={data.representativeTemplate} />
    </Flex>
  );
};
